import * as CONSTANTS from "../store/constants";
import router from "../router/index.js"

export default {
  data() {
    return {
      CONSTANTS
    };
  },
  methods: {
    navigateToHome() {
      location.href = process.env.VUE_APP_LANDING_PAGE_API;
    },
    getDomainInfo(domain){
      if (domain === CONSTANTS.ADS_DOMAIN) {
        return {
          id: CONSTANTS.ADS_DOMAIN,
          name: CONSTANTS.ADS_DOMAIN,
          title: CONSTANTS.ADS_DOMAIN_TITLE,
          description: CONSTANTS.ADS_DOMAIN_DESCRIPTION
        };
      }
    },
    getDomainFAQs(domain){
      if (domain === CONSTANTS.ADS_DOMAIN) {
        return [
          {
            link:
              "Why can't I log in to my computer after changing my password?",
            content:
              "When you change your password\n" +
              "            remotely, it will only change your password on Autodesk's\n" +
              "            servers. It won't change the password on your computer. Use your\n" +
              "            old password to unlock your computer until you connect to\n" +
              "            Autodesk's network."
          },
          {
            link:
              "Will I be notified\n" +
              "            when my password is about to expire?",
            content: "Yes, you will be notified via email."
          },
          {
            link:
              "What happens if my password expires while I'm on leave or sabbatical?",
            content:
              "Don't worry. You can change your\n" +
              "            password here before you leave or when you get back, even if your\n" +
              "            password has expired."
          },
          {
            link:
              "Where can I find more information about changing my password and password requirements?",
            content:
              'Please visit the <a target="_blank" href="https://autodesk.service-now.com/helphub?id=evg-kb-article&sys_id=a96be423dbe73a80e5235bc0cf9619e1"><strong> FAQ for Passwords </strong></a> for password requirements, troubleshooting advice, and more.'
          }
        ];
      }
    }
  }
};
